import React from 'react';
import { Container, Breadcrumb } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Header = ({ title, breadcrumbs, onMenuToggle }) => {
  const navigate = useNavigate();
  const { user, canEdit, isAuditor } = useAuth();

  return (
    <header className="bg-white border-bottom shadow-sm mb-4">
      <Container fluid className="py-3">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-2">
            {/* Hamburger – mobile only */}
            <button
              type="button"
              className="btn btn-outline-secondary d-md-none"
              onClick={onMenuToggle}
              aria-label="القائمة"
              style={{ padding: '6px 10px' }}
            >
              <i className="bi bi-list fs-5"></i>
            </button>

            <div>
              {breadcrumbs && breadcrumbs.length > 0 && (
                <Breadcrumb className="mb-1">
                  {breadcrumbs.map((crumb, index) => (
                    <Breadcrumb.Item
                      key={index}
                      active={index === breadcrumbs.length - 1}
                      onClick={() => crumb.path && navigate(crumb.path)}
                      style={{ cursor: crumb.path ? 'pointer' : 'default' }}
                    >
                      {crumb.icon && <i className={`${crumb.icon} ms-1`}></i>}
                      {crumb.label}
                    </Breadcrumb.Item>
                  ))}
                </Breadcrumb>
              )}
              <h2 className="mb-0 fs-5 fs-md-4">{title}</h2>
            </div>
          </div>

          <div className="text-end">
            <div className="text-muted small d-none d-sm-block">
              <i className="bi bi-person-circle ms-1"></i>
              {user?.username || user?.email}
              <span className={`badge ms-2 ${canEdit ? 'bg-success' : 'bg-warning text-dark'}`} style={{ fontSize: '0.65rem' }}>
                {canEdit ? 'Admin' : isAuditor ? 'Auditor' : ''}
              </span>
            </div>
          </div>
        </div>
      </Container>
    </header>
  );
};

export default Header;
